// eslint-disable-next-line import/prefer-default-export
export function camelToName(key) {
    const name = key.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
    return name.replace(/\b\w/g, (char) => char.toUpperCase());
}
export const calculateNetAmount = (amount, discount, surcharge) => {
    let total = parseFloat(amount) || 0;
    const discountValue = parseFloat(discount) || 0;
    const surchargeValue = parseFloat(surcharge) || 0;
    total = total - discountValue + surchargeValue;
    return total % 1 === 0 ? total : total.toFixed(2);
};
